import React, { useState } from 'react';
import ConverterLayout from '../JsonTools/ConverterLayout'; // Reusing the layout
import { Alert } from '@mui/material';
import SEO, { createSoftwareAppSchema } from '../../components/SEO';
import ToolPageContainer from '../../components/ToolPageContainer';

function UrlEncoderDecoder() {
  const [decoded, setDecoded] = useState('https://example.com/?q=hello world&cat=1');
  const [encoded, setEncoded] = useState('https%3A%2F%2Fexample.com%2F%3Fq%3Dhello%20world%26cat%3D1');
  const [error, setError] = useState('');
  const [isEncoding, setIsEncoding] = useState(true);

  const handleConvert = () => {
    setError('');
    try {
      if (isEncoding) {
        if (!decoded.trim()) {
          setEncoded('');
          return;
        }
        setEncoded(encodeURIComponent(decoded));
      } else {
        if (!encoded.trim()) {
          setDecoded('');
          return;
        }
        setDecoded(decodeURIComponent(encoded));
      }
    } catch (e) {
      setError('Invalid input string.');
    }
  };

  const handleSwap = () => {
    setIsEncoding(!isEncoding);
    setError('');
  };

  const handleClear = () => {
    setDecoded('');
    setEncoded('');
    setError('');
  };

  return (
    <>
      <SEO
        title="URL Encoder & Decoder | URL Formatting | UmbrellaCo"
        description="Encode and decode URLs instantly online. Safely format special characters for web addresses and query strings."
        keywords="url encoder, url decoder, encode uri component, decode url online, url formatter"
        url="/text-tools/url-encoder"
        jsonLd={createSoftwareAppSchema(
          'URL Encoder & Decoder',
          'Safely encode and decode URL strings and query parameters.',
          'https://umbrellaco.in/text-tools/url-encoder',
          ['URL Tools', 'Text Encoding', 'Web Utilities']
        )}
      />
      <ToolPageContainer
        title="URL Encoder / Decoder"
        description="Encode special characters in URLs to safely pass them via HTTP, or decode encoded strings back into readable URLs."
        disablePadding
      >
      {error && <Alert severity="error" sx={{ mb: 2, mx: 2 }}>{error}</Alert>}
      <ConverterLayout
        title={isEncoding ? "URL Encode" : "URL Decode"}
        leftTitle={isEncoding ? "Decoded URL" : "Encoded URL"}
        rightTitle={isEncoding ? "Encoded URL" : "Decoded URL"}
        leftLanguage="plaintext"
        rightLanguage="plaintext"
        leftValue={isEncoding ? decoded : encoded}
        setLeftValue={isEncoding ? setDecoded : setEncoded}
        rightValue={isEncoding ? encoded : decoded}
        onConvert={handleConvert}
        onSwap={handleSwap}
        onClear={handleClear}
      />
      </ToolPageContainer>
    </>
  );
}

export default UrlEncoderDecoder;